import { render } from "./NotifysComponent.vue?vue&type=template&id=3e4bc927&scoped=true"
import script from "./NotifysComponent.vue?vue&type=script&lang=js"
export * from "./NotifysComponent.vue?vue&type=script&lang=js"

import "./NotifysComponent.vue?vue&type=style&index=0&id=3e4bc927&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4bc927"]])

export default __exports__